import CategoryIcon from "@mui/icons-material/Category";
import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import {
  Box,
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import { PageHeader, Spacer } from "common";
import I18n from "i18n-js";
import useIntegrationList, {
  IntegrationListContext,
} from "./useIntegrationList";

import IntegrationCreateMenu from "./IntegrationCreateMenu";
import IntegrationIcon from "./IntegrationIcon";
import { IntegrationStatus } from "./integrationApi";
import DataCard from "../../../components/DataCard/DataCard";

export default function Integrations() {
  const grid = useIntegrationList();

  return (
    <IntegrationListContext.Provider value={grid}>
      <DataCard
        {...grid}
        headerTitle={<IntegrationCreateMenu />}
        headerItems={['refresh']}
        canEdit
        editUrl=":id"
        cardActions={(params) => [
          <Stack
            direction="row"
            spacing={1}
            sx={{ alignItems: "center", padding: "8px" }}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: params.row.enabled
                  ? "success.main"
                  : "action.disabled",
              }}
            />
            {params.row.status === IntegrationStatus.Connected && (
              <LinkIcon color="success" />
            )}
            {params.row.status !== IntegrationStatus.Connected && (
              <LinkOffIcon color="disabled" />
            )}
          </Stack>
        ]}
        cardSettings={{
          header: {
            icon: (row) => <IntegrationIcon type={row.type} size="large"/>,
            titleField: "name"
          },
          body: (row) => {
            return (
              <Box>
                <Stack direction="row" spacing={1}>
                  {row.locations?.map((location: string) => {
                    return (
                      <Chip key={location} label={location} size="small" />
                    );
                  })}
                </Stack>
                <Typography>
                  Some account details or last activity
                </Typography>
              </Box>
            );
          }
        }}
      />
    </IntegrationListContext.Provider>
  );
}
